/**
 * Health API client — fetches /api/health without the standard apiRequest wrapper
 * to avoid triggering error toasts on background version polling.
 */

export interface HealthResponse {
  status: string;
  utcNow: string;
  version: string;
}

/**
 * Fetch the API health response. Returns null on any error so callers can
 * degrade gracefully rather than surface a noisy toast.
 */
export async function fetchHealth(): Promise<HealthResponse | null> {
  try {
    const response = await fetch('/api/health');
    if (!response.ok) {
      return null;
    }
    return (await response.json()) as HealthResponse;
  } catch {
    return null;
  }
}
